//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start
import { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";



const DeleteAlertSuccessfull = ({ strMessage, ...props }) => {
    return (
        <>
          {/* Bhagyashri P [23-11-2023] : BT-107432 Set Alerts - class changes start */}
            <Container data-testid="alert-log-delete-success-popup" fluid className='p-0 my-3'>
                <Row className='g-0'>                           
                    <Col className='d-flex flex-column justify-content-center align-items-center'>
                        <div className='icon-64 icon-checktick icon-positive mt-2'></div> 
                        <div data-testid = "alert-log-delete-success-message" className='font-medium font-size6 color-text'>{strMessage}</div>
                    </Col>                   
                </Row>                
            </Container> 
              {/* Bhagyashri P [23-11-2023] : BT-107432 Set Alerts - class changes end */}
        </>
    );
};
export default memo(DeleteAlertSuccessfull);
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End